export default "__VITE_ASSET__CPDTBbHp__"